var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden md:bottom-10 md:flex md:flex-col md:items-center md:space-y-4 md:justify-center"},[_c('div',[_c('user-image',{attrs:{"user":_vm.profile}})],1),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.profile.name)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }